import React, { useEffect } from 'react';
import get from 'lodash/get';

import RichText from '../../../components/atoms/RichText';
import Container from '../../../components/molecules/Container';
import Grid from '../../../components/molecules/Grid';

import * as locators from './locators';
import useStyles from './style';
import Typography from '../../../components/atoms/Typography';
import { analyticsData } from '../../../../constants/Analytics/analytics-data';
import { pushAnaylyticsData } from '../../../../utils/analytics';
import { getUId } from '../../../../utils/utility';

const EditorialText = props => {
  const description = get(props, 'fields.description', '');
  const classes = useStyles();
  const uid = getUId(props)
  const handleFormSubmit = (event) => {
    const name = event.target?.querySelector('#mce-FNAME')?.value || '';
    const email = event.target?.querySelector('#mce-EMAIL')?.value || '';

    let obj = {
      ...analyticsData.pageBodyInteraction['signUpFormMailchinmp'],
      ...{
        label: 'Signup Form',
        name,
        email
      },
    };
    pushAnaylyticsData(obj);
  };

  useEffect(() => {
    const form = document.querySelector('#mc-embedded-subscribe-form');
    if (form) form.addEventListener('submit', handleFormSubmit);

    return () => {
      if (form) form.removeEventListener('submit', handleFormSubmit);
    };
  }, []);

  const style = get(props, 'params.style', '')

  return description && description.value ? (
    <Container data-locator={locators.COMPONENT_NAME} uid={uid} className={`${classes.root} ${style === 'UpdatedFont' ? 'special-offers' : ""}`}>
      <Grid>
        <Typography component="div" variant="body1">
          <RichText innerHTML={description} className='player-wrapper richText' />
        </Typography>
      </Grid>
    </Container>
  ) : null;
};

export default EditorialText;
